import { useEffect, useRef } from 'react';
import Hls from 'hls.js';

export default function VideoPlayer({ src, poster, className }) {
  const ref = useRef(null);

  useEffect(() => {
    const video = ref.current;
    if (!video) return;

    // If HLS is supported and an m3u8 is provided, use hls.js
    if (Hls.isSupported() && src && src.endsWith('.m3u8')) {
      const hls = new Hls({ maxBufferLength: 30 });
      hls.loadSource(src);
      hls.attachMedia(video);
      return () => hls.destroy();
    }

    // Otherwise rely on native playback (Safari/iOS HLS or MP4)
    if (src) video.src = src;
  }, [src]);

  return (
    <video
      ref={ref}
      className={className}
      poster={poster}
      controls
      playsInline
      preload="metadata"
    />
  );
}